import React from 'react';
import { InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { useInputStyles, useResultStyles } from '../../../shared/components/UploadStyles';
import { StatusResult } from '../../../shared/enum/StatusResult';
import SucessImg from '../../../assets/sucess.svg';
import AlertImg from '../../../assets/alert.svg';
import ErrorImg from '../../../assets/error.svg';
import { Button, Grid, Typography } from '@material-ui/core';
import CustomAccordion from '../../../shared/components/CustomAccordion';
interface IUploadResultProps {
    result: InfluencerUploadResultModel,
    nameFile: string,
    hasHistoryButton: boolean,
    onClickHistory: () => void,
    onClickNewUpload: () => void,
    onClickStartClassification: () => void
}
let checkTodosInfluencerInseridos = false;

export function InfluencerAutorizationResult({ result, nameFile, hasHistoryButton, onClickHistory, onClickNewUpload, onClickStartClassification }: IUploadResultProps) {
    const classes = useResultStyles();
    const styles = useInputStyles();
    const QuotaLimit: any = sessionStorage.getItem('ignoreQuotaLimit') ? sessionStorage.getItem('ignoreQuotaLimit') : 'false';

    function getTitle(): string {
        if (result.status == StatusResult.ERROR) {
            if (result.property == 'SpreadsheetAccess')
                return 'Não foi possível validar o influenciador.';

            return 'Ocorreu um problema ao validar o Influenciador.';
        } else {
            if (result.quantityInserted > 0 || result.quantityInserted < 0)
                return 'Influenciador validado com sucesso!';
            else
                return 'Não foi possível validar o influenciador.';
        }
    }

    function ignoreQuotaLimit() {
        sessionStorage.setItem('ignoreQuotaLimit', 'true');
        onClickNewUpload();
    }

    function getSubTitle() {
        checkTodosInfluencerInseridos = false;
        if (!result.quotaOverflow) {
            if (result.quantityInserted > 0 || result.quantityInserted < 0) {
                if (result.quantityDuplicated > 0) {
                    return (
                        <div style={{ width: 600 }}>
                            <div className={styles.textStart}>{`${result.quantityInserted.toString()} de ${result.quantityTotal.toString()} validado com sucesso.`}</div>
                            <div className={styles.textStart}>{`${result.quantityDuplicated.toString()} perfis duplicados, consulte o dashboard.`}</div>
                            <br />
                            <div className={styles.textStart}>{'Controle de cotas:'}</div>
                            <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                            <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                            <div className={styles.textStart}>{`• Quantidade restante:  ${result.quantityRemaining}`}</div>
                        </div>
                    );
                } else
                    return (
                        <div style={{ width: 600 }}>
                            <div className={styles.textStart}>{'Tudo pronto! Influenciador validado.'}</div>
                            <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                            <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                            <div className={styles.textStart}>{`• Quantidade restante:  ${result.quantityRemaining}`}</div>
                        </div>
                    );
            } else {
                checkTodosInfluencerInseridos = true;
                return 'Todos os influenciadores enviados já foram analisados, portanto, nenhum dado foi validado. Consulte o dashboard.';
            }
        } else {
            return (
                <div style={{ width: 600 }}>
                    <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                    <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                    <div className={styles.textStart}>{`• Quantidade restante:  ${result.quantityRemaining}`}</div>
                </div>
            );
        }
    }

    function getIcon() {
        if (result.status == StatusResult.ERROR) {
            return (
                <div className={classes.icon}>
                    <img src={ErrorImg} alt="" />
                </div>
            );
        } else {
            if (result.quantityInserted > 0 || result.quantityInserted < 0)
                return (
                    <div className={classes.icon}>
                        <img src={SucessImg} alt="" />
                    </div>
                );
            else
                return (
                    <div className={classes.icon}>
                        <img src={AlertImg} alt="" />
                    </div>
                );
        }
    }


    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            <Typography variant="h4" className={classes.title}>
                {getTitle()}
            </Typography>
            <Typography variant="body1" className={classes.item}>
                {getSubTitle()}
            </Typography>
            {(result.quantityDuplicated > 0 && result.registeredInfluencersMessage) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result?.registeredInfluencersMessage} title={'Influenciadores já cadastrados!'} />
                </div>
            )}

            {(result.status == StatusResult.ERROR) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result.message} title={result.title} />
                </div>
            )}
            {getIcon()}
            <Typography variant="subtitle1" className={classes.nameFile}>
                {nameFile}
            </Typography>
            {/* {result.quantityInserted > 0 || result.quantityInserted < 0 && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickStartClassification}>
                    INICIAR CLASSIFICAÇÃO
                </Button>
            )} */}
            {/* {result.quantityInserted == 0 && hasHistoryButton && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickHistory}>
                    VERIFICAR HISTÓRICO DE PLANILHAS
                </Button>
            )} */}
            {(result.quantityInserted == 0 && result.status != StatusResult.ERROR && !checkTodosInfluencerInseridos) && (
                <Typography variant="body1" className={classes.item}>
                    Se não quiser ultrapassar o limite da cota, volte para a “Classificação”.
                </Typography>
            )}

            {(result.quantityInserted == 0 && result.status != StatusResult.ERROR && !checkTodosInfluencerInseridos) && (
                <>
                    <Button
                        size="large"
                        // variant="outlined"
                        disabled={QuotaLimit == 'false' ? false : true}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={ignoreQuotaLimit}>
                        Ignorar limites e validar
                    </Button>
                    <Button
                        size="large"
                        // variant="outlined"
                        variant="contained"
                        color="inherit"
                        className={classes.button}
                        onClick={onClickStartClassification}>
                        Voltar para a tela de Classificação
                    </Button>
                </>
            )}

            {(result.quantityInserted > 0 || result.quantityInserted < 0 || result.status == StatusResult.ERROR || checkTodosInfluencerInseridos) && (<Button
                size="large"
                // variant="outlined"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onClickStartClassification}>
                Voltar para a tela de Classificação
            </Button>)}
        </Grid>
    );
}